import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { SingleCampaignSelector, MultiCampaignSelector, SingleCampaignSelectorwWthDropdownMenu, MultiCampaignSelectorWthDropdownMenu, AccountCampaignSelector } from './selector-control';
import { MultiSelectedItemComponent } from './components/multi-selected-item';

/**
 * A business component of campaign selector based on entity selector
 * support single mode and multi mode
 */

export class CampaignSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggled: props.isToggled,
      selectedItem: props.selectedItem,
      resultList: [],
    };
    const { i18n, i18nLegacy } = this.props;
    this.i18n = i18nLegacy || i18n;
    this.resultContainerOptions = this.getResultContainerOptions();
  }

  /**
   * for the multi mode: after the Done btn clicked, should toggle the dropdown, and call back
   * @param {object} items - selected result adgroups
   * @returns {undefined} do not need return
   */
  onSelectDone = (items) => {
    this.toggle();
    this.props.onSelectDone(items);
  }

  /**
   * for the multi mode: after the Cancel btn clicked, should toggle the dropdown, and call back
   * @returns {undefined} do not need return
   */
  onSelectCancel = () => {
    this.toggle();
    this.props.onSelectCancel();
  }

  /**
   * for multi mode: dropdown btn will show lick this: ** items selected
   * @returns {selectedItem} return an item which can be used for dropdown button to show
   */
  getSelectedItemForMultiMode = () => {
    const resultListLen = this.state.resultList.length;
    const selectedText = this.i18n.getString(this.props.stringKeys.resultHeader, {
      itemCount: resultListLen,
    });
    return resultListLen ? { name: selectedText } : null;
  };

  /**
   * for multi mode: prepare the params for the withDropdownMenu hoc
   * @returns {undefined} do not need return
   */
  getDropdownOptions = () => {
    const { campaign, isMultiMode } = this.props;
    const renderDropdownText = (item) => {
      if (campaign && !isMultiMode) {
        return (
          <span>
            <span className={classnames('selected-item-parent-text', 'selected-item')}>
              {campaign.Name}
            </span>
            <span className="selected-item">
              {'>'}
            </span>
            <span className="selected-item" title={item.name}>
              {item.name}
            </span>
          </span>);
      }
      const text = this.props.getCustomDropdownText ?
        this.props.getCustomDropdownText() : item.name;

      return (
        <span className="selected-item" title={text}>
          {text}
        </span>);
    };

    const renderEmptyDropdownText = () => {
      if (isMultiMode) {
        return this.props.getCustomDropdownText ?
          this.props.getCustomDropdownText() :
          this.i18n.getString(this.props.stringKeys.selectEntities);
      }
      return this.i18n.getString(this.props.stringKeys.selectEntity);
    };

    return {
      isToggled: this.state.isToggled,
      toggle: this.toggle,
      renderDropdownText,
      renderEmptyDropdownText,
      selectedItem: isMultiMode ? this.getSelectedItemForMultiMode() : this.state.selectedItem,
      updatedDropdownItem: this.updatedDropdownItem,
      ariaLabel: renderEmptyDropdownText(),
    };
  }

  /**
   * for multi mode: prepare the params for the withMultiResultContainer hoc
   * @returns {undefined} do not need return
   */
  getResultContainerOptions = () => {
    const { stringKeys, resultContainerOptions } = this.props;
    const renderHeader = itemCount => (
      <div className="panel-heading">
        <h4 className="panel-title">
          {this.i18n.getString(stringKeys.resultHeader, {
            itemCount,
          })}
        </h4>
      </div>);

    const renderEmptyList = () => (
      <div className="empty-content">
        {this.i18n.getString(this.props.stringKeys.emptyListContent)}
      </div>
    );

    const renderItem = (item, index) =>
      (<MultiSelectedItemComponent
        item={item}
        index={index}
        campaign={this.props.campaign}
        hideStatus={this.props.hideStatus}
      />);

    const onResultChanged = (resultList) => {
      this.setState({ resultList });
    };

    const defaultOptions = {
      renderHeader,
      renderEmptyList,
      renderItem,
      onSelectDone: this.onSelectDone,
      onSelectCancel: this.onSelectCancel,
      pageSize: this.props.pageSize,
      onResultChanged,
    };

    const options = resultContainerOptions ?
      _.defaults(resultContainerOptions, defaultOptions) : defaultOptions;
    return options;
  }

  /**
  * will update the seleted item info in the dropdown btn
  * @param {object} selectedItem the item selected
  * @returns {undefined} update the Dropdown btn info
  */
  updatedDropdownItem = (selectedItem) => {
    this.setState({ selectedItem });
  }

  /**
   * control the toggle state
   * @returns {undefined} update the state
   */
  toggle = () => {
    this.setState({ isToggled: !this.state.isToggled });
  }

  renderSelector = () => {
    const { isMultiMode, withDropdownMenu, withAccountSelector } = this.props;
    if (withDropdownMenu) {
      if (isMultiMode && withAccountSelector) {
        return (<AccountCampaignSelector
          {...this.props}
          dropdownOptions={this.getDropdownOptions()}
          resultContainerOptions={this.resultContainerOptions}
          i18n={this.props.i18n}
          i18nLegacy={this.props.i18nLegacy}
        />);
      }

      return (isMultiMode ?
        <MultiCampaignSelectorWthDropdownMenu
          {...this.props}
          dropdownOptions={this.getDropdownOptions()}
          resultContainerOptions={this.resultContainerOptions}
          i18n={this.props.i18n}
          i18nLegacy={this.props.i18nLegacy}
        /> :
        <SingleCampaignSelectorwWthDropdownMenu
          {...this.props}
          dropdownOptions={this.getDropdownOptions()}
          i18n={this.props.i18n}
          i18nLegacy={this.props.i18nLegacy}
        />);
    }
    return (isMultiMode ?
      <MultiCampaignSelector
        {...this.props}
        resultContainerOptions={this.resultContainerOptions}
        i18n={this.props.i18n}
        i18nLegacy={this.props.i18nLegacy}
      /> :
      <SingleCampaignSelector
        {...this.props}
        i18n={this.props.i18n}
        i18nLegacy={this.props.i18nLegacy}
      />);
  }

  render() {
    return (
      <div className={classnames('ba-campaign-selector')}>
        {this.renderSelector()}
      </div>
    );
  }
}

CampaignSelector.propTypes = {
  /**
   * item count per page
   */
  pageSize: PropTypes.number,
  /**
   * function to fetch items
   */
  fetch: PropTypes.func.isRequired,
  /**
   * callback to pass selected item and it's index outside
   */
  onSelect: PropTypes.func.isRequired,
  /**
   * selected item
   */
  selectedItem: PropTypes.objectOf(PropTypes.any),
  /**
   * i18n for localization
   */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }),
  /**
   * i18n for localization
   */
  i18nLegacy: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }),
  /**
   * keys for customized strings
   */
  stringKeys: PropTypes.objectOf(PropTypes.string),
  /**
   * Used to check whether an item is selected.
   *
   * @param {Object} selectedItem - selected item
   * @param {Object} item - single data in the list
   * @return {boolean} - whether current item is selected
   */
  checkSelected: PropTypes.func,
  /**
   * judge whhether campaign selector is used as adgroup selector
   */
  campaign: PropTypes.objectOf(PropTypes.any),
  /**
    * the campaign adgroup selector mode: multi or single
    */
  isMultiMode: PropTypes.bool,
  /**
    * the initial selected item list for multi mode
    */
  selectedItemsForMultiMode: PropTypes.arrayOf(PropTypes.any),
  /**
    * callback for the Done btn clicked, with the selected items
    */
  onSelectDone: PropTypes.func,
  /**
    * callback for the Cancel btn clicked, with the selected items
    */
  onSelectCancel: PropTypes.func,
  /**
    * hide campaign status in selected container of multi mode
    */
  hideStatus: PropTypes.bool,
  /**
    * with Dropdown Menu or not
    */
  withDropdownMenu: PropTypes.bool,
  /**
    * customize the resultContainerOptions
    */
  resultContainerOptions: PropTypes.objectOf(PropTypes.any),
  /**
    * aria-label for campaign list selector
    */
  ariaLabel: PropTypes.string,
  /**
    * aria-label for result campaign list
    */
  resultListAriaLabel: PropTypes.string,
  /**
   * aria label of search box input
   */
  searchBoxAriaLabel: PropTypes.string,
  /**
   * customize OriginCampaignSelector
   */
  originCampaignSelectorOptions: PropTypes.shape({}),
  /**
   * message bar configuration
   */
  messageConfig: PropTypes.shape({}),
  /**
   * custom render function for dropdown text
   */
  getCustomDropdownText: PropTypes.func,
  /**
   * custom dropdown menu is toggled at beginning
   */
  isToggled: PropTypes.bool,
  /**
    * with account selector or not
    */
  withAccountSelector: PropTypes.bool,
  /**
    * customize the multiAccountSelectorOptions
    */
  multiAccountSelectorOptions: PropTypes.shape({}),
};

CampaignSelector.defaultProps = {
  pageSize: 10,
  selectedItem: null,
  stringKeys: {
    emptyListContent: 'CampaignSelector_EmptyList_Content',
    listHeader: 'CampaignSelector_List_Header',
    selectEntity: 'CampaignSelector_SelectCampaign',
    selectEntities: 'CampaignSelector_SelectCampaigns',
    resultHeader: 'CampaignSelector_Result_List_Header',
    actionBar: 'CampaignSelector_Result_Action_Bar',
  },
  checkSelected: (selectedItem, item) => _.isEqual(selectedItem, item),
  campaign: null,
  isToggled: false,
  isMultiMode: false,
  onSelectDone: _.noop,
  onSelectCancel: _.noop,
  i18n: null,
  i18nLegacy: null,
  selectedItemsForMultiMode: [],
  hideStatus: false,
  withDropdownMenu: true,
  resultContainerOptions: null,
  ariaLabel: '',
  resultListAriaLabel: '',
  searchBoxAriaLabel: '',
  originCampaignSelectorOptions: {},
  messageConfig: {},
  getCustomDropdownText: undefined,
  withAccountSelector: false,
  multiAccountSelectorOptions: {},
};
